import { CONFIG } from "../../config";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";
import {
  IncidentSummary,
  PaymentHealthHistoryResponse,
  PaymentHealthStatusResponse,
  SimulatePaymentEventsInput,
  SimulatePaymentEventsResult,
} from "../../interfaces/paymentHealth.interface";

const BASE = "/payment-health";

export async function getPaymentHealthStatus(): Promise<PaymentHealthStatusResponse> {
  const axios = await getTokenizedAxios();
  return axios
    .get<PaymentHealthStatusResponse>(
      `${CONFIG.ADMIN_SERVER.BASE_URL}${BASE}/status`
    )
    .then((res) => res.data);
}

export async function getPaymentHealthHistory(
  days?: number
): Promise<PaymentHealthHistoryResponse> {
  const axios = await getTokenizedAxios();
  const query = days ? `?days=${days}` : "";
  return axios
    .get<PaymentHealthHistoryResponse>(
      `${CONFIG.ADMIN_SERVER.BASE_URL}${BASE}/history${query}`
    )
    .then((res) => res.data);
}

export async function resolveIncident(
  incidentId: string,
  note?: string
): Promise<IncidentSummary> {
  const axios = await getTokenizedAxios();
  return axios
    .post<IncidentSummary>(
      `${CONFIG.ADMIN_SERVER.BASE_URL}${BASE}/incidents/${incidentId}/resolve`,
      { note }
    )
    .then((res) => res.data);
}

export async function markIncidentFalsePositive(
  incidentId: string,
  note?: string
): Promise<IncidentSummary> {
  const axios = await getTokenizedAxios();
  return axios
    .post<IncidentSummary>(
      `${CONFIG.ADMIN_SERVER.BASE_URL}${BASE}/incidents/${incidentId}/false-positive`,
      { note }
    )
    .then((res) => res.data);
}

export async function simulatePaymentEvents(
  input: SimulatePaymentEventsInput
): Promise<SimulatePaymentEventsResult> {
  const axios = await getTokenizedAxios();
  return axios
    .post<SimulatePaymentEventsResult>(
      `${CONFIG.ADMIN_SERVER.BASE_URL}${BASE}/simulate-events`,
      input
    )
    .then((res) => res.data);
}
